import { gql } from 'apollo-angular';
import { Tenant } from '../../shared/entities/tenant/tenant';

export const TENANT_QUERY = gql`
query getTenantQuery(
  $id: String
)
{
  tenant: getTenantByTenantId(
    tenantId: $id
  )
  {
    id
    name
    additionalName
    email
    description
    addressLine0
    addressLine1
    postalCode
    city
    country
    phone
    vatNumber
    vatType
    tenantId
  },
}
`;

export interface TenantQueryResponse {
  tenant: Tenant;
  loading: boolean;
}
